import { EntityDefinition } from '@/types/crud';

export const benchmarkEntity: EntityDefinition = {
  name: 'Benchmark',
  displayName: 'Benchmarks',
  displayNameSingular: 'Benchmark',
  apiEndpoint: '/benchmarking',
  key: 'benchmarks',
  fields: [
    {
      key: 'name',
      label: 'Benchmark Name',
      type: 'text',
      required: true,
      order: 1
    },
    {
      key: 'description',
      label: 'Description',
      type: 'textarea',
      required: false,
      order: 2
    },
    {
      key: 'benchmark_year',
      label: 'Benchmark Year',
      type: 'number',
      required: true,
      order: 3,
      defaultValue: new Date().getFullYear()
    },
    {
      key: 'start_date',
      label: 'Start Date',
      type: 'date',
      required: true,
      order: 4
    },
    {
      key: 'end_date',
      label: 'End Date',
      type: 'date',
      required: true,
      order: 5
    },
    {
      key: 'status',
      label: 'Status',
      type: 'select',
      required: true,
      order: 6,
      defaultValue: 'DRAFT',
      options: [
        { value: 'DRAFT', label: 'Draft' },
        { value: 'ACTIVE', label: 'Active' },
        { value: 'FROZEN', label: 'Frozen' },
        { value: 'CLOSED', label: 'Closed' },
        { value: 'ARCHIVED', label: 'Archived' }
      ]
    },
    {
      key: 'currency',
      label: 'Currency',
      type: 'select',
      required: true,
      order: 7,
      defaultValue: 'USD',
      options: [
        { value: 'USD', label: 'USD' },
        { value: 'EUR', label: 'EUR' },
        { value: 'GBP', label: 'GBP' },
        { value: 'JPY', label: 'JPY' },
        { value: 'CAD', label: 'CAD' },
        { value: 'AUD', label: 'AUD' }
      ]
    },
    {
      key: 'fte_definition',
      label: 'FTE Definition',
      type: 'textarea',
      required: false,
      order: 8
    },
    {
      key: 'scopeBusinessIds',
      label: 'Scope (Business units)',
      type: 'multiselect',
      required: false,
      order: 9,
      optionsEndpoint: '/hierarchy/business',
      optionsValueField: 'id',
      optionsLabelField: 'name'
    },
    {
      key: 'scopeGeographyIds',
      label: 'Scope (Geographies)',
      type: 'multiselect',
      required: false,
      order: 10,
      optionsEndpoint: '/hierarchy/geographic',
      optionsValueField: 'id',
      optionsLabelField: 'name'
    },
    {
      key: 'scopeFunctionIds',
      label: 'Scope (Functions)',
      type: 'multiselect',
      required: false,
      order: 11,
      optionsEndpoint: '/hierarchy/functional',
      optionsValueField: 'id',
      optionsLabelField: 'name'
    },
    {
      key: 'scopeProcessIds',
      label: 'Scope (Processes)',
      type: 'multiselect',
      required: false,
      order: 12,
      optionsEndpoint: '/admin/process-admin/processes',
      optionsValueField: 'id',
      optionsLabelField: 'name'
    }
  ],
  displayFields: ['name', 'description', 'benchmark_year', 'start_date', 'end_date', 'status', 'currency', 'fte_definition'],
  searchFields: ['name', 'description'],
  sortField: 'created_at',
  sortOrder: 'desc',
  deletable: true
};